

import React from "react";

import { Route, Routes } from "react-router-dom";
//import { useSelector } from "react-redux";
import Home from "../views/view.home";

// Activation links once pointed to this site (medichelp.savantech.org) instead of Medic Admin:
// forward them, token included, so links already sent by SMS or e-mail keep working.
export const ADMIN_ACTIVATION_URL = "https://savantech-5a5d4-e2948.web.app/activation";

function ToActivation() {
    React.useEffect(() => {
        window.location.replace(ADMIN_ACTIVATION_URL + window.location.search);
    }, []);
    return <p style={{ padding: 40, textAlign: "center" }}>Redirection vers l'activation de votre compte…</p>;
}


export default function BasicRouting() {

    //const user = useSelector((state)=> state.userReducer.user);

    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/activation" element={<ToActivation />} />
            <Route path="*" element={<Home />} /> 
        </Routes>
    )
}

